import { DollarOutlined } from "@ant-design/icons";

export const PaymentDetails = (props) => {
  const { selectedBooking } = props;
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        <DollarOutlined style={{ fontSize: "20px", color: "#1890ff" }} />
        <h3 style={{ margin: 0, color: "#333" }}>Payment Details</h3>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "10px",
        }}
      >
        <p style={{ margin: 0 }}>
          <strong>Total Amount:</strong>
          <span style={{ color: "#52c41a", fontWeight: "bold" }}>
            {selectedBooking.totalamount || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Transaction ID:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.transactionId || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Payment Method:</strong>{" "}
          <span style={{ color: "#555" }}>
            {selectedBooking.paymentMethod || "N/A"}
          </span>
        </p>
        <p style={{ margin: 0 }}>
          <strong>Payment Status:</strong>
          <span
            style={{
              color:
                selectedBooking.paymentStatus === "Completed"
                  ? "#52c41a"
                  : selectedBooking.paymentStatus === "Pending"
                  ? "#faad14"
                  : "#ff4d4f",
              fontWeight: "bold",
            }}
          >
            {selectedBooking.paymentStatus || "N/A"}
          </span>
        </p>
      </div>
    </div>
  );
};
